/* eslint-disable no-console */
import kfetch from '@kareo/kfetch';
import UserRole from './kUserRoles';

const USERS_FOR_PRACTICE_PAGED_URL = '/common-ui/api/User/v2/page';

function isUserAdmin(user) {
  if (!user || !user.roles) {
    throw Error('Unable to load user roles');
  }
  return user.roles.includes(UserRole.ADMIN.valueOf());
}

let isRcmEmployeePromise;
function isRevenueCycleManagementEmployee(options = {}) {
  if (!isRcmEmployeePromise) {
    isRcmEmployeePromise = kfetch(
      '/common-ui/api/User/isUserRCMEmployee',
      options,
    );
  }
  return isRcmEmployeePromise;
}

async function getCurrentUser(options = {}) {
  return kfetch(`/common-ui/api/User/me`, options);
}

async function getCurrentUserInfo(options = {}) {
  return kfetch(`/common-ui/api/User/me/basic`, options);
}

async function getPreAuthSecureUserContact(options = {}) {
  return kfetch(`/login-ui/api/Login/active-user/secure`, options);
}

async function getAuthedSecureUserContact(options = {}) {
  return kfetch(`/login-ui/api/Login/admin-user/secure`, options);
}

async function getUserByGuid(userGuid, options = {}) {
  let url = `/common-ui/api/User/${userGuid}`;
  let user = await kfetch(url, options)
    .then(data => {
      return data;
    })
    .catch(error => {
      console.log(error);
      return undefined;
    });
  return user;
}

function applyUserFilters(filter = null, searchParams) {
  if (!!filter && !!searchParams) {
    if (!!filter?.search) {
      searchParams.append('filter', filter.search);
    }
    if (filter?.showLockedUsers !== filter?.showUnLockedUsers) {
      searchParams.append(
        'isLocked',
        !!filter?.showLockedUsers && !filter?.showUnLockedUsers,
      );
    }
    if (filter?.showProviders !== filter?.showNonProviders) {
      searchParams.append(
        'isProvider',
        !!filter?.showProviders && !filter?.showNonProviders,
      );
    }
  }
  return searchParams;
}

function getUsersForPracticePaged({
  pageNumber = 1,
  pageSize = 10,
  filter = {},
  options = {},
}) {
  let params = new URLSearchParams();
  if (!!pageNumber) {
    params.append('pageNumber', pageNumber);
  }
  if (!!pageSize) {
    params.append('pageSize', pageSize);
  }
  params = applyUserFilters(filter, params);
  return kfetch(
    `${USERS_FOR_PRACTICE_PAGED_URL}?${params.toString()}`,
    options,
  );
}

function validateUserPassword(password) {
  if (!password) {
    return false;
  }
  let hasNumbers = password.match(/^(?=.*\d).{8,}$/g) ? 1 : 0;
  let hasMinusChars = password.match(/^(?=.*[a-z]).{8,}$/g) ? 1 : 0;
  let hasMayusChars = password.match(/^(?=.*[A-Z]).{8,}$/g) ? 1 : 0;
  let hasSpecialChars = password.match(
    /^(?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]).{8,}$/g,
  )
    ? 1
    : 0;
  return (
    hasNumbers + hasMinusChars + hasMayusChars + hasSpecialChars >= 3 &&
    password.length > 0
  );
}

export default {
  isUserAdmin,
  isRevenueCycleManagementEmployee,
  getCurrentUser,
  getCurrentUserInfo,
  getPreAuthSecureUserContact,
  getAuthedSecureUserContact,
  getUserByGuid,
  getUsersForPracticePaged,
  validateUserPassword,
};
